import React, { useState } from 'react';
import { Card, Form, Button, Alert } from 'react-bootstrap';
import { changePassword } from '../../api/userApi';

const ChangePassword = () => {

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        setError('');
        setSuccess('');

        if (newPassword.length < 6) {
            setError('Le nouveau mot de passe doit contenir au moins 6 caractères.');
            return;
        }

        if (newPassword !== confirmPassword) {
            setError('Le nouveau mot de passe et sa confirmation ne correspondent pas.');
            return;
        }

        try {

            const userId = localStorage.getItem('userId');

            await changePassword({
                userId: Number(userId),
                currentPassword,
                newPassword
            });

            setSuccess('Mot de passe modifié avec succès.');

            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');

        } catch (err) {

            if (err.response?.data?.message) {
                setError(err.response.data.message);
            } else {
                setError('Erreur lors de la modification du mot de passe.');
            }
        }
    };

    const passwordMismatch =
        confirmPassword.length > 0 &&
        newPassword !== confirmPassword;

    return (
        <div className="container mt-4">

            <Card className="shadow-sm">

                <Card.Header className="bg-primary text-white">
                    <h4 className="mb-0">
                        🔒 Changer le mot de passe
                    </h4>
                </Card.Header>

                <Card.Body>

                    {error && (
                        <Alert variant="danger">
                            {error}
                        </Alert>
                    )}

                    {success && (
                        <Alert variant="success">
                            {success}
                        </Alert>
                    )}

                    <Form onSubmit={handleSubmit}>

                        {/* MOT DE PASSE ACTUEL */}
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Mot de passe actuel
                            </Form.Label>

                            <Form.Control
                                type="password"
                                value={currentPassword}
                                onChange={(e) =>
                                    setCurrentPassword(e.target.value)
                                }
                                placeholder="Saisissez votre mot de passe actuel"
                                required
                            />
                        </Form.Group>

                        {/* NOUVEAU MOT DE PASSE */}
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Nouveau mot de passe
                            </Form.Label>

                            <Form.Control
                                type="password"
                                value={newPassword}
                                onChange={(e) =>
                                    setNewPassword(e.target.value)
                                }
                                placeholder="Minimum 6 caractères"
                                required
                            />
                        </Form.Group>

                        {/* CONFIRMATION */}
                        <Form.Group className="mb-4">
                            <Form.Label>
                                Confirmer le nouveau mot de passe
                            </Form.Label>

                            <Form.Control
                                type="password"
                                value={confirmPassword}
                                onChange={(e) =>
                                    setConfirmPassword(e.target.value)
                                }
                                placeholder="Confirmez le nouveau mot de passe"
                                required
                                isInvalid={passwordMismatch}
                            />

                            <Form.Control.Feedback type="invalid">
                                Les mots de passe ne correspondent pas.
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Button
                            variant="primary"
                            type="submit"
                        >
                            🔑 Changer le mot de passe
                        </Button>

                    </Form>

                </Card.Body>

            </Card>

        </div>
    );
};

export default ChangePassword;